
import { View } from "@/models/view";
import { Highlight } from "@/utils/views/highlight";
import Vue from "vue";
import AppHighlightEdit from "./HighlightEdit.vue";
import { getModel, Model } from "@/utils/models/model";
import { Browse } from "@/models/browse";
import { BrowseService } from "@/services";
import { ViewColumn } from "@/utils/views/view-column";

export default Vue.extend({
	data(){
		return {
			toEditHighlight: null as null | Highlight,
			toEditIndex: -1
		};
	},
	props: {
		view: {
			type: Object as ()=>View,
			required: true
		},
		column: {
			type: Object as ()=>ViewColumn,
			required: true
		}
	},
	computed: {
		model():Model{
			return getModel(this.view.Table);
		},
		browse(): Browse | null {
			return BrowseService.getBrowseWithoutViewSettings(this.view.BrowseID);
		},
		sortableAttributes():any{
			return {
				items: this.column.Highlights,
				disableX: true,
				keepInY: true,
				tag: "w-list",
				targetClass: "handle"
			};
		}
	},
	methods: {
		addClicked(){
			this.column.Highlights.push(new Highlight());
		},
		removeHighlight(i:number){
			this.column.Highlights.splice(i,1);
		},
		onEditCondition(i:number){
			this.toEditIndex = i;
			this.toEditHighlight = this.column.Highlights[i];
		},
		onHighlightInput(highlight:Highlight){
			if (this.toEditIndex < 0) return;
			this.column.Highlights[this.toEditIndex] = highlight;
		},
		close(){
			this.$emit("close");
		}
	},
	components: {
		AppHighlightEdit
	},
	i18nEx: {
		componentPrefix: "components.view-editor"
	}
});
